import { Inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { BUNDLE_TYPE_TEXT_MAP, SETTINGS_SERVICE } from '../constants';
import { NodeModel } from '../models';
import { BaseSettingsGetService } from '../services';

@Pipe({
    name: 'bundleLabel',
    standalone: false
})

export class BundleLabelPipe implements PipeTransform {

  constructor(
    private readonly translateServive: TranslateService,
    @Inject(SETTINGS_SERVICE) private readonly settingsService: BaseSettingsGetService,
    @Inject(BUNDLE_TYPE_TEXT_MAP) public bundleTypeTextMap: { [key: string]: string },
  ) {}

  transform(value: NodeModel & { customTypeId?: string, baseType?: string }): Observable<string> {
    if (!value) {
      return of('');
    }

    const bundleKey = value.baseType || value.bundle;
    const fallbackLabel = this.bundleTypeTextMap[bundleKey];
    
    if (value.customTypeId) {
      return this.settingsService.getSettings()
        .pipe(
          mergeMap(settings => {
            const currentType = settings.lesson?.customTypes?.find(type => type?.uuid === value.customTypeId);

            return currentType?.label ? of(currentType?.label) :  this.translateServive.get(fallbackLabel);
          })
        );
    }

    return this.translateServive.get(fallbackLabel);
  }
}